<div class="control-panel" style="width: 400px !important">
  <h3 class="text-center width-100">
    Add Row
    <i
      class="fa fa-times pull-right close-sidenav"
      aria-hidden="true"
      title="Close Text Block"
      (click)="closeNav()"
    ></i>
  </h3>
  <div
    class="container"
    title="One Column"
    tabindex="0"
    (click)="submitRow('col-1', 1); closeNav()"
    (keyup.enter)="submitRow('col-1', 1); closeNav()"
  >
    <div class="row">
      <div class="col-12"><div class="box-row"></div></div>
    </div>
  </div>
  <div
    class="container"
    title="Two Columns : 50% distribution"
    tabindex="0"
    (click)="submitRow('col-21', 1); closeNav()"
    (keyup.enter)="submitRow('col-21', 1); closeNav()"
  >
    <div class="row">
      <div class="col-6"><div class="box-row"></div></div>
      <div class="col-6"><div class="box-row"></div></div>
    </div>
  </div>
  <div
    class="container"
    title="Two Columns : 33%-67% distribution"
    tabindex="0"
    (click)="submitRow('col-2-1-2', 1); closeNav()"
    (keyup.enter)="submitRow('col-2-1-2', 1); closeNav()"
  >
    <div class="row">
      <div class="col-4"><div class="box-row"></div></div>
      <div class="col-8"><div class="box-row"></div></div>
    </div>
  </div>
  <div
    class="container"
    title="Two Columns : 67%-33% distribution"
    tabindex="0"
    (click)="submitRow('col-2-2-1', 1); closeNav()"
    (keyup.enter)="submitRow('col-2-2-1', 1); closeNav()"
  >
    <div class="row">
      <div class="col-8"><div class="box-row"></div></div>
      <div class="col-4"><div class="box-row"></div></div>
    </div>
  </div>
  <div
    class="container"
    title="Two Columns : 75%-25% distribution"
    tabindex="0"
    (click)="submitRow('col-2-3-1', 1); closeNav()"
    (keyup.enter)="submitRow('col-2-3-1', 1); closeNav()"
  >
    <div class="row">
      <div class="col-9"><div class="box-row"></div></div>
      <div class="col-3"><div class="box-row"></div></div>
    </div>
  </div>
  <div
    class="container"
    title="Two Columns : 25%-75% distribution"
    tabindex="0"
    (click)="submitRow('col-2-1-3', 1); closeNav()"
    (keyup.enter)="submitRow('col-2-1-3', 1); closeNav()"
  >
    <div class="row">
      <div class="col-3"><div class="box-row"></div></div>
      <div class="col-9"><div class="box-row"></div></div>
    </div>
  </div>
  <div
    class="container"
    title="Three Columns : 33% distribution"
    tabindex="0"
    (click)="submitRow('col-31', 1); closeNav()"
    (keyup.enter)="submitRow('col-31', 1); closeNav()"
  >
    <div class="row">
      <div class="col-4"><div class="box-row"></div></div>
      <div class="col-4"><div class="box-row"></div></div>
      <div class="col-4"><div class="box-row"></div></div>
    </div>
  </div>
  <div
    class="container"
    title="Three Columns : 25% - 50% - 25% distribution"
    tabindex="0"
    (click)="submitRow('col-3-1-2-1', 1); closeNav()"
    (keyup.enter)="submitRow('col-3-1-2-1', 1); closeNav()"
  >
    <div class="row">
      <div class="col-3"><div class="box-row"></div></div>
      <div class="col-6"><div class="box-row"></div></div>
      <div class="col-3"><div class="box-row"></div></div>
    </div>
  </div>
  <div
    class="container"
    title="Three Columns : 50% - 25% - 25% distribution"
    tabindex="0"
    (click)="submitRow('col-3-2-1-1', 1); closeNav()"
    (keyup.enter)="submitRow('col-3-2-1-1', 1); closeNav()"
  >
    <div class="row">
      <div class="col-6"><div class="box-row"></div></div>
      <div class="col-3"><div class="box-row"></div></div>
      <div class="col-3"><div class="box-row"></div></div>
    </div>
  </div>
  <div
    class="container"
    title="Three Columns : 25% - 25% - 50% distribution"
    tabindex="0"
    (click)="submitRow('col-3-1-1-2', 1); closeNav()"
    (keyup.enter)="submitRow('col-3-1-1-2', 1); closeNav()"
  >
    <div class="row">
      <div class="col-3"><div class="box-row"></div></div>
      <div class="col-3"><div class="box-row"></div></div>
      <div class="col-6"><div class="box-row"></div></div>
    </div>
  </div>
  <div
    class="container"
    title="Four Columns : Even distribution"
    tabindex="0"
    (click)="submitRow('col-421', 1); closeNav()"
    (keyup.enter)="submitRow('col-421', 1); closeNav()"
  >
    <div class="row">
      <div class="col-3"><div class="box-row"></div></div>
      <div class="col-3"><div class="box-row"></div></div>
      <div class="col-3"><div class="box-row"></div></div>
      <div class="col-3"><div class="box-row"></div></div>
    </div>
  </div>
  <div
    class="container"
    title="Six Columns : Even distribution"
    tabindex="0"
    (click)="submitRow('col-632', 1); closeNav()"
    (keyup.enter)="submitRow('col-632', 1); closeNav()"
  >
    <div class="row">
      <div class="col-2"><div class="box-row"></div></div>
      <div class="col-2"><div class="box-row"></div></div>
      <div class="col-2"><div class="box-row"></div></div>
      <div class="col-2"><div class="box-row"></div></div>
      <div class="col-2"><div class="box-row"></div></div>
      <div class="col-2"><div class="box-row"></div></div>
    </div>
  </div>
</div>
